export const LICENSE_KEY = '4753f-02fc4-11055-b4e1f-d8d12'